export const PROFILE_AVATAR_MIMES = Object.freeze([
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
]);

export function resolveProfileAvatarUrl(reference, apiBase) {
  if (!reference) return "";
  const value = String(reference);
  if (/^(?:https?:|blob:|data:)/i.test(value)) return value;

  const base = String(apiBase || "").replace(/\/api\/?$/, "");
  if (!base) return value;
  return `${base}${value.startsWith("/") ? "" : "/"}${value}`;
}

export function createAvatarCanvasSource(reference, cacheToken = Date.now()) {
  if (!reference) return "";
  const value = String(reference);
  if (!/^https?:/i.test(value)) return value;

  const separator = value.includes("?") ? "&" : "?";
  return `${value}${separator}avatar_crop=${encodeURIComponent(String(cacheToken))}`;
}

export function confirmedAvatarReference(savedProfile, refreshedProfile) {
  const savedReference = savedProfile?.avatar || "";
  return savedReference && refreshedProfile?.avatar === savedReference
    ? savedReference
    : "";
}

export function isAvatarRemovalConfirmed(savedProfile, refreshedProfile) {
  return !savedProfile?.avatar && !refreshedProfile?.avatar;
}
